import Layout, { LayoutType, LayoutElement, LayoutElementType } from 'domain/entity/layout';

import ReadLayoutsCriteria from 'use-case/layout/read/readLayoutsCriteria';
import { getArrayApiClient } from 'adapter/out/client/apiClient';

const asLayouts = (layoutsJson: LayoutJson[]) =>
    layoutsJson.map((layoutItem: LayoutJson) => ({ type: layoutItem.type as LayoutType, widgets: asLayoutElements(layoutItem.widgets) }));

export const asLayoutElements = (layoutWidgetElementsJson: LayoutElementJson[]): LayoutElement[] =>
    layoutWidgetElementsJson.map((element) => ({
        id: element.id,
        position: element.position,
        size: element.size,
        type: element.type as LayoutElementType,
        constraints: {
            minWidth: element.size_constraints.min_width,
            maxWidth: element.size_constraints.max_width,
            minHeight: element.size_constraints.min_height,
            maxHeight: element.size_constraints.max_height,
        },
    }));

const readLayoutsApiClient = getArrayApiClient(
    (criteria: ReadLayoutsCriteria) => `dashboards/dashboards/${criteria.dashboardId}/layouts`,
    Layout,
    undefined,
    asLayouts
);

export type LayoutJson = {
    type: string;
    widgets: LayoutElementJson[];
};

export type LayoutElementJson = {
    id: string;
    position: { x: number; y: number };
    type: string;
    size: { width: number; height: number };
    ['size_constraints']: {
        ['min_width']: number;
        ['min_height']: number;
        ['max_width']: number;
        ['max_height']: number;
    };
};

export default readLayoutsApiClient;
